import React from 'react';
import { Progress } from 'antd';

interface DepartmentOkrWidgetProps {
    rowSpan?: number;
    colSpan?: number;
}

const data = [
    { department: 'HR', total: 130, percentage: 85 },
    { department: 'SATIŞ', total: 300, percentage: 72 },
    { department: 'IT', total: 86, percentage: 56 },
    { department: 'TEDARİK ZİNCİRİ', total: 75, percentage: 48 },
];

const DepartmentOkrWidget: React.FC<DepartmentOkrWidgetProps> = () => {
    return (
        <div className="h-full w-full p-4 bg-white rounded shadow">
            <h2 className="text-lg font-bold text-center mb-4">DEPARTMAN OKR'LARI</h2>

            {/* Header bar */}
            <div className="flex bg-gradient-to-r from-blue-500 to-blue-400 text-white font-semibold text-sm rounded-t-md overflow-hidden">
                <div className="w-1/3 px-2 py-1 text-left">DEPARTMAN</div>
                <div className="w-1/3 px-2 py-1 text-center">OKR SAYISI</div>
                <div className="w-1/3 px-2 py-1 text-center">OKR GİRİŞ</div>
            </div>

            {/* Data rows */}
            <div className="bg-white divide-y divide-gray-200 rounded-b-md">
                {data.map((item, idx) => (
                    <div key={idx} className="flex items-center text-sm text-black px-2 py-3">
                        <div className="w-1/3 font-semibold">{item.department}</div>
                        <div className="w-1/3 text-center">{item.total}</div>
                        <div className="w-1/3 flex justify-center">
                            <Progress
                                className={"h-[50px]"}
                                type="dashboard"
                                percent={item.percentage}
                                width={80}
                                strokeColor="#7300ff"
                                gapDegree={180}
                                format={p => `${p}%`}
                                // background arc color
                                trailColor="#e5e5e5"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DepartmentOkrWidget;
